import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { PurchasePopup } from './components/Interactive';
import { Hero, StatsBar } from './components/HeroAndStats';
import { InitialTestimonials, FinalTestimonials, Guarantee } from './components/SocialProof';
import { PainPoints, ProductOverview, Comparison } from './components/ProblemSolution';
import { Tomos, Bonus, EliteUpsell } from './components/ProductDetails';
import { Countdown, Pricing } from './components/PricingAndUrgency';
import { FAQ, Footer } from './components/FAQAndFooter';
export function App() {
  useEffect(() => {
    // Defer pixel init until the browser is idle so the external fbevents.js
    // fetch doesn't compete with the first paint (faster perceived load).
    const w = window as any;
    const start = () => initMetaPixel();
    if (typeof w.requestIdleCallback === 'function') {
      const id = w.requestIdleCallback(start, {
        timeout: 3000
      });
      return () => w.cancelIdleCallback?.(id);
    }
    const t = setTimeout(start, 1500);
    return () => clearTimeout(t);
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-teal-200 selection:text-teal-900" data-id="element-0">
      {/* Floating Elements */}
      <PurchasePopup data-id="element-1" />

      {/* Main Content Flow */}
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <InitialTestimonials data-id="element-5" />
        <PainPoints data-id="element-6" />
        <ProductOverview data-id="element-7" />
        <Tomos data-id="element-8" />
        <Bonus data-id="element-9" />
        <Countdown data-id="element-10" />
        <Pricing data-id="element-11" />
        <EliteUpsell data-id="element-12" />
        <Comparison data-id="element-13" />
        <FinalTestimonials data-id="element-14" />
        <Guarantee data-id="element-15" />
        <FAQ data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
    </div>;
}